import BasicLayout from '../layauots/BasicLayout';
import { Card } from '@mui/material';
import MDBox from '../controls/MDBox';
import MDTypography from '../controls/MDTypography';
import MDButton from '../controls/MDButton';
import People from "@mui/icons-material/People";
import { Link } from 'react-router-dom';
import bgImage from "../../assets/images/bg-sign-up-cover.jpeg";
const Confirmacion = () => {
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            ¡Registro exitoso!
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Revisa tu casilla de correo electrónico
          </MDTypography>

        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">

            <MDTypography coloredshadow="success"
              textAlign="center" fontWeight="regular" color="dark">
              ¡Bienvenido a DataMuni! Tu registro fue exitoso. En unos minutos recibirás un correo con el código y las instrucciones para activar tu usuario y comenzar a explorar la plataforma.
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox height="150px" textAlign="center">
          <MDButton component={Link} to="/ActivarCuenta"
            variant="gradient"
            color="success"
            endIcon={<People />}
          >
            Activa tu Cuenta!
          </MDButton>
          
        </MDBox>
      </Card>
    </BasicLayout >
   
  );
};

export default Confirmacion;


